import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

const clientsData = [
  { id: 1, imageUrl: '/assets/images/clints/watad.webp', altText: 'Watad Academy' },
  { id: 2, imageUrl: '/assets/images/clints/abwab.jpeg', altText: 'Abwab Platform' },
  { id: 3, imageUrl: '/assets/images/clints/almaher.jpg', altText: 'Almaher School' },
  { id: 4, imageUrl: '/assets/images/clints/edu.png', altText: 'EduTech' },
  { id: 5, imageUrl: '/assets/images/clints/qout.webp', altText: 'Qout App' },
  { id: 6, imageUrl: '/assets/images/clints/ordarat.webp', altText: 'Ordarat POS' },
  { id: 7, imageUrl: '/assets/images/clints/joacademy.jpg', altText: 'JoAcademy' },
  { id: 8, imageUrl: '/assets/images/clints/codeprooo_logo.jpeg', altText: 'CodePro' },
  { id: 9, imageUrl: '/assets/images/clints/green.jpg', altText: 'GreenTech' },
  { id: 10, imageUrl: '/assets/images/clints/dekn.png', altText: 'Dekan Platform' },
  { id: 11, imageUrl: '/assets/images/clints/redtag.png', altText: 'Red Tag Marketing' },
];

function Clients() {
  return (
    <div className="container-fluid clients py-5">
      <div className="container">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={10}
          loop={true}
          autoplay={{ delay: 0, disableOnInteraction: false }}
          speed={3000}
          grabCursor={true}
          breakpoints={{
            320: { slidesPerView: 3 },
            768: { slidesPerView: 6 },
            1024: { slidesPerView: 10 },
          }}
        >
          {clientsData.map(client => (
            <SwiperSlide key={client.id}>
              <div className="client-logo position-relative">
                <img
                  src={client.imageUrl}
                  alt={client.altText}
                  className="img-fluid"
                />
                <div className="client-overlay d-flex justify-content-center align-items-center">
                  <span>{client.altText}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default Clients;
